"use strict";
!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="49f1c188-f9e3-5d65-8982-628f444bf738")}catch(e){}}();

Object.defineProperty(exports, "__esModule", { value: true });
exports.PolicyType = void 0;
var PolicyType;
(function (PolicyType) {
    PolicyType["PERSONAL"] = "Personal";
    PolicyType["COMMERCIAL"] = "Commercial";
})(PolicyType || (exports.PolicyType = PolicyType = {}));
//# sourceMappingURL=insurance-contract.js.map
//# debugId=49f1c188-f9e3-5d65-8982-628f444bf738
